module.exports = __webpack_public_path__ + "img/地址.fc572001.svg";